import { Button, Grid, Typography } from '@material-ui/core';
import { ebookBookTemplateActions, gameBookTemplateActions } from '@orientaction/api-actions';
import ContainerAdmin from '@orientaction/commons/ContainerAdmin';
import MarginContainer from '@orientaction/commons/MarginContainer';
import { ItemEbook, ItemGame, Layout } from '@orientaction/components';
import { EbookListItem, GameListItem, GameSetupResponse } from '@orientaction/types';
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { apiServiceNative } from '../../../utils/fetchNative';
import style from '../style';
import SkeletonList from './skeleton';

const ListGame: FC = () => {
  const classes = style();
  const history = useHistory();
  const [list, setList] = useState<GameListItem[]>([]);
  const [listEbook, setListEbook] = useState<EbookListItem[]>([]);
  const [options, setOptions] = useState<GameSetupResponse>();
  const [loading, setLoading] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState(() => {
    const fromEbook = sessionStorage.getItem('fromEbook');
    return fromEbook ? 'ebook' : 'game';
  });

  const getListGame = async () => {
    setLoading(true);
    const response: GameListItem[] = await apiServiceNative.get('/api/game-list');
    setList(response);
    setLoading(false);
  };

  const getListEbooks = async () => {
    setLoading(true);
    const response: EbookListItem[] = await apiServiceNative.get('/api/ebook-list');
    setListEbook(response);
    setLoading(false);
  };

  const getOptions = async () => {
    const response: GameSetupResponse = await apiServiceNative.get('/api/setup-game');
    setOptions(response);
  };

  const deletePagesTemps = async (pages: any) => {
    await apiServiceNative.get(`/api/remove-pages?pageId=${pages}`);
    sessionStorage.removeItem('idPagesTemps');
  };

  const deleteFiles = async (pages: any) => {
    await apiServiceNative.get(`/api/remove-files?fileId=${pages}`);
    localStorage.removeItem('idFILESTemps');
  };

  const deleteVariablesTemps = async (pages: any) => {
    try {
      await apiServiceNative.get(`/api/remove-variables?pageId=${pages}`);
      sessionStorage.removeItem('idVariablesTemps');
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const idPagesTemps: any = sessionStorage.getItem('idPagesTemps');
        const idvariablesTemps: any = sessionStorage.getItem('idVariablesTemps');
        if (idPagesTemps) {
          const pages = JSON.parse(idPagesTemps);
          await deletePagesTemps(pages);
        }
        if (idvariablesTemps) {
          const pages = JSON.parse(idvariablesTemps);
          await deleteVariablesTemps(pages);
        }
        await getListGame();
        await getOptions();
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const idFilesTemps: any = localStorage.getItem('idFILESTemps');
      if (idFilesTemps) {
        const files = JSON.parse(idFilesTemps);
        await deleteFiles(files);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (activeTab !== 'game') {
        await getListEbooks();
        sessionStorage.clear();
      } else if (activeTab === 'game') {
        await getListGame();
      }
    })();
  }, [activeTab]);

  const callBackDelete = async (isDeleted: boolean) => {
    if (isDeleted) {
      await getListGame();
    }
  };

  const callBackDeleteBooks = async (isDeleted: boolean) => {
    if (isDeleted) {
      await getListEbooks();
    }
  };

  const dispatch = useDispatch();

  return (
    <Layout isaddBackground={true} showOverFlow={true}>
      <ContainerAdmin>
        <MarginContainer big={true}>
          <Typography variant="h2" style={{ marginBottom: '40px' }}>
            Administrer les ressources{' '}
          </Typography>
          <Grid container={true} className={classes.separatorGrid}>
            <Grid item={true}>
              <Button
                className={classes.btnTab}
                style={activeTab === 'game' ? { background: '#000A8C', color: 'white' } : {}}
                onClick={() => setActiveTab('game')}
                size="large"
              >
                Serious games
              </Button>
              <Button
                className={classes.btnTab}
                style={activeTab === 'ebook' ? { background: '#000A8C', color: 'white' } : {}}
                onClick={() => setActiveTab('ebook')}
                size="large"
              >
                E-books
              </Button>
            </Grid>
          </Grid>
          {activeTab === 'game' && (
            <>
              <Grid
                container={true}
                spacing={2}
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item={true} sm="auto">
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.btnPrimary}
                    style={{ margin: '30px 0px 20px' }}
                    onClick={() => {
                      history.push('/admin/game/create');
                      dispatch(gameBookTemplateActions.resetValues());
                      sessionStorage.clear();
                    }}
                  >
                    Créer un nouveau jeu
                  </Button>
                </Grid>
              </Grid>
              {loading && <SkeletonList />}
              <div>
                {!loading &&
                  list.map((game: any, index: number) => (
                    <ItemGame
                      slugEn={game.slugEn}
                      key={game.id ?? index}
                      id={game.id}
                      title={game.title}
                      pageNumber={game.pages}
                      status={game.status}
                      callBack={callBackDelete}
                      options={options}
                      permission={game?.authorizations}
                    />
                  ))}
              </div>
            </>
          )}
          {activeTab === 'ebook' && (
            <>
              <Grid
                container={true}
                spacing={2}
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item={true} sm="auto">
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.btnPrimary}
                    style={{ margin: '30px 0px 20px' }}
                    onClick={() => {
                      dispatch(ebookBookTemplateActions.resetValuesEbooks());
                      sessionStorage.clear();
                      history.push('/admin/ebook/create');
                    }}
                  >
                    Créer un nouvel ebook
                  </Button>
                </Grid>
              </Grid>

              {loading && <SkeletonList />}
              <div>
                {!loading &&
                  listEbook.map((b: any, index: number) => (
                    <ItemEbook
                      key={b.id ?? index}
                      id={b.id}
                      title={b.title}
                      status={b.status}
                      callBack={callBackDeleteBooks}
                      options={options}
                      permission={b?.authorizations}
                      slugEn={b?.slugEn}
                    />
                  ))}
              </div>
            </>
          )}
        </MarginContainer>
      </ContainerAdmin>
    </Layout>
  );
};

export default ListGame;
